export default __webpack_public_path__ + "static/media/07_photo.ca107034.jpg";